<template>
  <div v-lazy-load="shouldUseLazyLoad">
    <!-- brand header -->
    <div class="brand-container">
      <FashionHeader
        v-if="shouldShowHeader"
        :id="`${categoryKey}-${brandData.id}`"
        class="brand-header"
        :header-background-url="brandData.header_background"
        :header-logo-url="brandData.logo"
        :brand-id="brandData.id"
        :outfit-type="OutfitTypeEnum.SPLIT"
      />
    </div>
    <NewArrivalBadge :brand-data="brandData" :categoryKey="categoryKey"></NewArrivalBadge>
    <div :class="getClassForMixAndMatchContainer" v-if="visible">
      <div v-for="option in brandData.garments" :style="categoryStyle" :key="`option-${option.id}`">
        <MixAndMatchWithSectionTraitPreview
          :option="option"
          :categoryKey="categoryKey"
          :brand-id="brandData.id"
          :brand-background="brandData.store_background"
          :category-details="categoryDetails"
          :tab-navigation-enabled="tabNavigationEnabled"
        />
      </div>
    </div>
  </div>
</template>

<script>
import FashionHeader from '@/components/AvatarBuilderUI/Fashion/FashionHeader';
import FeatureGating from '@/services/FeatureGating';
import MixAndMatchWithSectionTraitPreview from '@/components/AvatarBuilderUI/TraitPreviews/MixAndMatchWithSectionTraitPreview';
import { OutfitTypeEnum } from '@/enum/outfit_type';
import NewArrivalBadge from '@/components/AvatarBuilderUI/NewArrivalBadge';
export default {
  name: 'AvatarBuilderMixAndMatchCategory',
  props: [
    'brandIndex', //: Number
    'brandData', //: Object
    'categoryKey', //: String
    'categoryStyle', //: Object
    'brandNum', //: Number
    'categoryDetails', //: Object,
    'shouldForceLoadBrand', //:Boolean
    'tabNavigationEnabled', //:Boolean
  ],
  components: {
    FashionHeader,
    MixAndMatchWithSectionTraitPreview,
    NewArrivalBadge,
  },
  created: function() {
    this.OutfitTypeEnum = OutfitTypeEnum;
  },
  data: function() {
    return {
      visible: false, // Managed by LazyLoad
      observer: null, // Managed by LazyLoad
    };
  },
  computed: {
    shouldUseLazyLoad() {
      return !this.shouldForceLoadBrand && this.brandIndex >= 1;
    },
    shouldShowHeader() {
      return this.brandNum > 1;
    },
    getClassForMixAndMatchContainer() {
      return FeatureGating.isUpdatedTraitNavEnabled()
        ? 'mix-and-match-traits-container-padded'
        : 'mix-and-match-traits-container';
    },
  },
};
</script>

<style scoped>
.brand-container {
  display: flex;
  flex-direction: column;
}

.brand-header {
  flex-basis: 60px;
  width: 100%;
}

.mix-and-match-traits-container {
  /* Use all the available space in parent relative positioned */
  /* Height is set in traitsContainerStyle since we want different height for the mix and match category */
  width: 100%;

  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  box-sizing: border-box;
}

.mix-and-match-traits-container-padded {
  /* Use all the available space in parent relative positioned */
  /* Height is set in traitsContainerStyle since we want different height for the mix and match category */
  width: 100%;

  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  box-sizing: border-box;
  padding-bottom: 20px;
  padding-top: 10px;
}
</style>
